const IsraelSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111648)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M27.5311 15.6525H22.5106L20.0004 11.3047L17.4904 15.6525H12.4697L14.9802 20.0003L12.4697 24.3481H17.4904L20.0004 28.6959L22.5106 24.3481H27.5311L25.0207 20.0003L27.5311 15.6525ZM23.0844 20.0003L21.5425 22.6712H18.4586L16.9164 20.0003L18.4585 17.3294H21.5425L23.0844 20.0003ZM20.0004 14.6584L20.5743 15.6524H19.4267L20.0004 14.6584ZM15.3743 17.3294H16.5221L15.9482 18.3234L15.3743 17.3294ZM15.3743 22.6712L15.9483 21.6772L16.5222 22.6712H15.3743ZM20.0004 25.3422L19.4266 24.3481H20.5743L20.0004 25.3422ZM24.6265 22.6712H23.4787L24.0527 21.6772L24.6265 22.6712ZM23.4787 17.3294H24.6265L24.0526 18.3234L23.4787 17.3294Z"
        fill="#0052B4"
      />
      <path
        d="M32.4503 4.34863H7.5508C5.72557 5.80238 4.16025 7.56816 2.93604 9.56605H37.0651C35.8408 7.56824 34.2755 5.80238 32.4503 4.34863Z"
        fill="#0052B4"
      />
      <path
        d="M7.5508 35.652H32.4503C34.2755 34.1982 35.8408 32.4325 37.065 30.4346H2.93604C4.16033 32.4324 5.72564 34.1982 7.5508 35.652Z"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111648">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default IsraelSvg;
